module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1604-min.a6f41208.jpg";